import { useQuery } from '@tanstack/react-query';
import { customAxiosInstanceMutator } from './custom-axios-instance';

export interface IndividualKycStatus { customerId?: string; kycLastUpdated?: string | null }
const url = (id: string) => `/customer/api/v1/customers/${encodeURIComponent(id)}/individual-kyc`;

export const confirmIndividualKyc = (id: string) =>
  customAxiosInstanceMutator<IndividualKycStatus>({ url: url(id), method: 'POST' });

export const useIndividualKyc = (id?: string) => useQuery({
  queryKey: ['individualKyc', id],
  queryFn: () => customAxiosInstanceMutator<IndividualKycStatus>({ url: url(id!), method: 'GET' }),
  enabled: !!id
});

export function individualKycStatus(timestamp?: string | null, now = Date.now()) {
  if (!timestamp) return { status: 'missing', message: 'KYC has never been performed', daysAgo: null };
  const checkedAt = Date.parse(timestamp);
  if (!Number.isFinite(checkedAt) || checkedAt > now) {
    return { status: 'missing', message: 'KYC date is invalid; confirmation is required', daysAgo: null };
  }
  const daysAgo = Math.ceil((now - checkedAt) / 86400000);
  return { status: daysAgo > 90 ? 'outdated' : 'current',
    message: `KYC was last updated ${daysAgo} days ago`, daysAgo };
}
